<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.标签管理')}}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click="checkCreate">
            <i class="iconfont" >&#xe727;</i>
            {{$t('message.新建')}}
          </el-button>
          </el-link>
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont" >&#xe667;</i>
            {{$t('message.刷新')}}
          </el-button>
          </el-link>
          <el-link
            href="/manage/wechat/exporttags"
            :underline="false"
          >
            <el-button size="medium" round :loading="false">
              <i class="iconfont" >&#xe769;</i>
              {{$t('message.导出')}}
            </el-button>
          </el-link>
        </div>
      </div>
      <div class="grid-content content-margin">
        <el-divider></el-divider>
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.筛选')}}</span>
            </td>
            <td >
              <el-input
              v-model="search"
              size="mini"
              :placeholder="$t('message.输入关键字搜索')"/>
            </td>
          </tr>
        </table>
      </div>
      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="filterData"
          stripe
          border
          :height="tableHeight"
          style="width: 100%;">
          <el-table-column
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column
            prop="id"
            :label="$t('message.标签ID')"
            width="300">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('message.标签名称')"
            >
          </el-table-column>
          <el-table-column
            prop="count"
            :label="$t('message.标签下的用户数')"
            width="300">
          </el-table-column>
          <el-table-column width="200" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" round type="normal" icon="el-icon-edit" @click="editDialogVisible = true; targetRow = scope.row; tempName = scope.row.name;"></el-button>
                <el-button size="mini" round type="normal" icon="el-icon-download" @click="exportDialogVisible = true; targetRow = scope.row;"></el-button>
                <el-button size="mini" round type="normal" icon="el-icon-delete" @click="deleteDialogVisible = true; targetRow = scope.row;"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        :title="$t('message.创建标签')"
        :visible.sync="createDialogVisible"
        width="400px"
        :modal="false"
        center
        :before-close="handleClose"
      >
        <textarea
            wrap="soft|hard"
            class="dialog-textarea"
            v-model="tempName"
            :placeholder="$t('message.请输入标签名称')"
            @keyup.enter.stop="createTag"
          />
        <span slot="footer" class="dialog-footer">
          <el-button @click="createDialogVisible = false;">{{$t('message.取消')}}</el-button>
          <el-button type="primary" @click.native="createTag">{{$t('message.创建')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('message.编辑标签')"
        :visible.sync="editDialogVisible"
        width="400px"
        :modal="false"
        center
        :before-close="handleClose"
      >
        <textarea
            wrap="soft|hard"
            class="dialog-textarea"
            v-model="tempName"
            :placeholder="$t('message.请输入标签名称')"
            @keyup.enter.stop="createTag"
          />
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false;">{{$t('message.取消')}}</el-button>
          <el-button type="primary" @click.native="editTag">{{$t('message.编辑')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('message.删除确认')"
        :visible.sync="deleteDialogVisible"
        width="300px"
        :modal="false"
        center
        :before-close="handleClose"
      >
          <i class="iconfont" >&#xe766;</i>
          <span>{{$t('message.请确认是否删除该标签')}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="deleteTag">{{$t('message.删除')}}</el-button>
          </span>
      </el-dialog>

      <el-dialog
        :title="$t('message.导出')"
        :visible.sync="exportDialogVisible"
        width="300px"
        :modal="false"
        center
      >
        <span style="display: inline-block;">{{$t('message.导出用户数据耗时较长请确认是否导出')}}</span>
        <!-- show-checkbox
          :check-on-click-node="true"
          :check-strictly="true" -->
        <!-- @node-click="handleNodeClick" -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="exportDialogVisible = false">{{$t('message.取消')}}</el-button>
          <el-button type="primary" @click.native="exportTag">{{$t('message.导出')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$t('message.正在导出用户数据')"
        :visible.sync="userExportDialogVisible"
        width="600px"
        :modal="true"
        center
        :show-close="false"
        :before-close="handleClose"
      >
        <el-row>
          <span class="simpleLabel" style="margin-bottom: 10px;">{{$t('message.当前状态')+ progressState}}{{dot}}</span>
        </el-row>
        <el-row>
        <el-progress :text-inside="true" :stroke-width="16" :percentage="percentageUserExport"></el-progress>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-link
            :href="'/manage/wechat/downloadtagusers?handlekey='+handlekeyExport"
            v-show="endExportUser" 
            :underline="false"
          >
            <el-button size="small" icon="el-icon-download" round @click="userExportDialogVisible = false">
              {{$t('message.下载')}}
            </el-button>
          </el-link>
          <el-link
            v-show="endExportUser" 
            :underline="false"
          >
            <el-button size="small" round @click="userExportDialogVisible = false">
              {{$t('message.关闭')}}
            </el-button>
          </el-link>
          
          <el-button v-show="!endExportUser" round size="small" @click="cancelUserExport">{{$t('message.取消')}}</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "TagManage",
  data() {
    return {
      tableHeight: 500,
      filterText: "",
      tempName: "",
      createDialogVisible: false,
      editDialogVisible: false,
      deleteDialogVisible: false,
      exportDialogVisible: false,
      userExportDialogVisible: false,
      progressState: "",
      targetRow: null,
      tableData: [],
      search: "",
      timedotCount: 0,
      timeHandleExportUser: null,
      percentageUserExport: 0,
      handlekeyExport: null,
      endExportUser: false,
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 150;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    refresh() {
      this.$http.get("/manage/wechat/gettags", {}).then((doc) => {
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
        } else {
          console.log(doc.data);
          this.tableData = doc.data.data.tags;
        }
      });
    },
    checkCreate() {
      try{
        if (this.tableData.length >= 100) {
        this.$message({
          type: "error",
          message: this.$t('message.该主体的标签数量已达上限'),
        });
      } else this.createDialogVisible = true;
      }catch(e){
        console.log(e);
        this.createDialogVisible = true;
      }
      
    },
    exportAll() {
      this.$http.get("/manage/wechat/exporttags", {}).then((doc) => {
        // console.log(doc.data)
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
        } else {
          this.tableData = doc.data.data;
        }
      });
    },
    createTag() {
      this.$http
        .post("/manage/wechat/addtag", {
          name: this.tempName.replace(/[\r\n]/g, ""),
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
          this.refresh();
          this.createDialogVisible = false;
        });
    },
    editTag() {
      console.log(this.targetRow);
      this.$http
        .post("/manage/wechat/edittag", {
          id: this.targetRow.id,
          name: this.tempName.replace(/[\r\n]/g, ""),
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
          this.refresh();
          this.editDialogVisible = false;
        });
    },
    deleteTag() {
      console.log(this.targetRow);
      this.$message({
        type: "error",
        message: "此功能二期再做",
      });
      this.deleteDialogVisible = false;
    },
    exportTag() {
      this.exportDialogVisible = false;
      // 提交
      this.$http
        .get("/manage/wechat/exporttagusers", {
          params: { tagid: this.targetRow.id },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            // 打开进度条面板
            this.percentageUserExport = 0;
            this.endExportUser = false;
            this.userExportDialogVisible = true;
            this.handlekeyExport = doc.data.data;
            // 开启定时器
            window.clearInterval(this.timeHandleExportUser);
            this.timeHandleExportUser = setInterval(() => {
              this.onProgressCommit();
            }, 400);
          }
        });
    },
    onProgressCommit() {
      this.timedotCount++;
      if (this.timedotCount > 3) {
        this.timedotCount = 0;
      }

      // 发送请求
      this.$http
        .get("/manage/wechat/progressexporttagusers", {
          params: { handlekey: this.handlekeyExport },
        })
        .then((doc) => {
          console.log(doc.data);
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
            // 如果完成了就停下计时器
            clearInterval(this.timeHandleExportUser);
            this.timeHandleExportUser = null;
            this.timedotCount = 0;
            this.endExportUser = true;
            this.progressState = doc.data.Message;
          } else {
            let data = doc.data.data;
            this.percentageUserExport =
              data.total == 0
                ? 0
                : parseInt((data.progress / data.total) * 100);

            if (data.ExtendData) {
              this.reportCommitTag = data.ExtendData;
            }

            this.progressState =
              data.Message + " (" + data.progress + "/" + data.total + ")";

            if (doc.data.data.isEnd == true) {
              // 如果完成了就停下计时器
              clearInterval(this.timeHandleExportUser);
              this.timeHandleExportUser = null;
              this.timedotCount = 0;
              this.endExportUser = true;

              if (doc.data.data.data == "FAIL") {
                this.$message({
                  type: "error",
                  message: doc.data.data.Message,
                });
              }
            }
          }
        });
    },
    cancelUserExport() {
      this.$http
        .get("/manage/wechat/progressexporttagusers", {
          params: { handlekey: this.handlekeyExport },
        })
        .then((doc) => {
          console.log(doc.data);
          this.commitTagDialogVisible = false;
          clearInterval(this.timeHandleCommit);
          this.timeHandleCommit = null;
        });
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {
    dot() {
      switch (this.timedotCount) {
        case 1:
          return ".";
        case 2:
          return "..";
        case 3:
          return "...";
      }
      return "";
    },
    filterData() {
      if (this.tableData)
        return this.tableData.filter(data => !this.search || data.name.toLowerCase().includes(search.toLowerCase()) || data.id.toString().toLowerCase().includes(this.search.toLowerCase()))
      else
        return [];
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/wechatTag/TagManage.vue